import { render } from "./UpsertClientComponent.vue?vue&type=template&id=31d4cc34&scoped=true"
import script from "./UpsertClientComponent.vue?vue&type=script&lang=js"
export * from "./UpsertClientComponent.vue?vue&type=script&lang=js"

import "./UpsertClientComponent.vue?vue&type=style&index=0&id=31d4cc34&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d4cc34"]])

export default __exports__